export const mensajesGenerales = {
  formValidacion: {
    campoObligatorio: 'Este campo es obligatorio',
    fechaInvalida: 'Fecha inválida',
    horaInvalida: 'Hora inválida',
    fechaMinima: 'Debe ser mayor al 31/12/1899',
    fechaMaxima: 'Debe ser menor al 31/12/2099',
    emailValido: 'Debe ser un email válido',
    telefonoInvalido: 'El número de teléfono es inválido',
    cuitInvalido: "El CUIT es inválido",
    mayorACero: "Debe ser mayor a Cero",
    haOcurridoUnError: 'Ha ocurrido un error',
    numeroInvalido: 'Debe ser un número'
  },
}